import React, { Component, Fragment } from 'react';

import Heading from 'Components/Heading';
import SubHeading from 'Components/SubHeading';
import { getUser } from 'Utils/storage';
import { ReactComponent as TransporterIcon } from 'Icons/transporters-new.svg';


import GroupContainer from './GroupContainers';
import Checkbox from 'Components/Checkbox';


class GroupingProviders extends Component {
    constructor(props) {
        super(props);
        this.rfq = props.rfq;
        this.viewMode = props.viewMode;
        this.state = {
            groups: props.groups,
            transporters: props.transporters,
            rfq: this.rfq,
            searchText: "",
            offset: 0,
            limit: 50,
            isAllTransportersChecked: props.rfq.isAllTransporters || false
        }
    }
    componentDidMount() {
        if (this.rfq.autoSelectTransporters) {
            this.rfq.setGroups(this.props.groups || []);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if(nextProps.groups && this.props.groups && JSON.stringify(nextProps.groups) !== JSON.stringify(this.props.groups)) {
            this.rfq.setGroups([]);
        }
    }
    onChange=(e)=>{
        this.setState({
            searchText: e.target.value,
            limit: 10,
            offset: 0
        }, ()=>{this.props.searchGroupsAndTransporters(this.state.searchText)});
    }
    toggleTransporter = (groupIndex, transporter)=> {
        if(this.viewMode) {
            return;
        }
        const group = [...this.props.groups][groupIndex];
        const rfqGroups = [...this.rfq.groups];
        const rfqGroupIndex = rfqGroups.findIndex((rfqGroup)=> {
            return rfqGroup.id === group.id;
        });
        const rfqGroup = rfqGroups[rfqGroupIndex];
        if(this.props.alreadyExistTransporters && this.props.alreadyExistTransporters.includes(transporter.id)) {
            return;
        }
        if(rfqGroup) {
            const rfqTransporters = (rfqGroup.transporters || []);
            const transporterIndex = rfqTransporters.findIndex((rfqTransporter)=> {
                return rfqTransporter.id === transporter.id
            });
            if(transporterIndex < 0) {
                rfqGroup.transporters.push(transporter);
            } else {
                rfqGroup.transporters.splice(transporterIndex, 1);
            }
            if(rfqGroup.transporters.length === 0) {
                rfqGroups.splice(rfqGroupIndex, 1);
            }
        } else {
            const groupToBePushed = {...group};
            groupToBePushed.transporters = [{...transporter}]; 
            rfqGroups.push(groupToBePushed);
        }
        if(this.props.setGroups) {
            this.props.setGroups(rfqGroups);
        }
        this.rfq.setGroups(rfqGroups);
        this.setState({
            rfq: this.rfq
        })
    }
    toggleAllTransporters = (groupIndex)=> {
        if(this.viewMode) {
            return;
        }
        const group = [...this.props.groups][groupIndex];
        const rfqGroups = [...this.rfq.groups];
        const rfqGroupIndex = rfqGroups.findIndex((rfqGroup)=> {
            return rfqGroup.id === group.id;
        });
        const rfqGroup = rfqGroups[rfqGroupIndex];
        let groupTransporterExist = 0;
        if(this.props.alreadyExistTransporters && this.props.alreadyExistTransporters.length > 0) {
            ((rfqGroups[rfqGroupIndex] || {}).transporters || []).forEach(transporter => {
                if(this.props.alreadyExistTransporters.includes(transporter.id)) {
                    groupTransporterExist += 1;
                }
            })
        }
        if(rfqGroup) {
            if(groupTransporterExist && (((group || {}).transporters || []).length !== groupTransporterExist)) {
                (rfqGroups[rfqGroupIndex] || {}).transporters = ((group || {}).transporters || []).filter(el => el.is_active);
            } else {
                rfqGroups.splice(rfqGroupIndex, 1);
            }
        }else {
            const groupToBePushed = {...group};
            groupToBePushed.transporters = [...(groupToBePushed.transporters || []).filter(el => el.is_active)];
            rfqGroups.push(groupToBePushed);
        }
        if(this.props.setGroups) {
            this.props.setGroups(rfqGroups);
        }
        this.rfq.setGroups(rfqGroups);
        this.setState({
            rfq: this.rfq
        })
    }
    selectAllTransporter = (transporter)=> {
        if(this.viewMode || this.state.isAllTransportersChecked) {
            return;
        }
        const rfqTransporters = [...this.rfq.transporters];
        const rfqTransporterIndex = rfqTransporters.findIndex((rfqTransporter)=> {
            return rfqTransporter.id === transporter.id;
        })
        if(rfqTransporterIndex < 0) {
            rfqTransporters.push(transporter);
        } else {
            rfqTransporters.splice(rfqTransporterIndex, 1);
        }
        this.rfq.setTransporters(rfqTransporters);
        this.setState({
            rfq: this.rfq
        })
    }
    checkAllTransporters = ()=> {
        if(this.viewMode) {
            return;
        }
        this.setState({
            isAllTransportersChecked: !this.state.isAllTransportersChecked
        }, ()=> {
            this.rfq.setIsAllTransporters(this.state.isAllTransportersChecked)
        })
    }
    render() {
        const { groups, transporters, submitted } = this.props;
        const erroText  = (this.rfq.minimumBiddersToCreateRfq && ((((rfqData.docs_and_transporters || {}).transporters || {}).transporter_ids || []).length < this.rfq.minimumBiddersCountToCreateRfq)) ? `Minimum Transporters To Be Selected ${this.rfq.minimumBiddersCountToCreateRfq}` : 'Select Atleast One Transporter';

        return (
            <div className="providersGroup ph-30 pv-30 mt-10 tStart">
                <div className='header flex'>
                        <TransporterIcon />
                        <div className='ml-10'>Transporters <sup className='error-color'>*</sup>
                            {(submitted && ((!this.state.isAllTransportersChecked && !this.rfq.groups.length && !this.rfq.transporters.length) || (this.rfq.minimumBiddersToCreateRfq ? (this.rfq.transporters.length < this.rfq.minimumBiddersCountToCreateRfq) : true))) && <span className="error-color fs-14 fSemibold op-7 ml-5">{erroText}</span>}
                        </div>
                </div>
                <input placeholder={'Search Transporters'} 
                    type="text" 
                    className="mr-30 wt-300 ht-40 search searchBorder mb-20 mt-20"
                    value={this.state.searchText}
                    onChange={this.onChange}
                />
                <div className='flex'>
                    {!this.viewMode &&  
                    <div className='col-2 mr-20 pcard'>
                        {groups && groups.length > 0 && 
                            <Fragment>
                                <SubHeading text="My Groups" className="pb-10 border-bottom-light"/>
                                {
                                    groups.map((group, index)=> {
                                        let selectedTransporters = [];
                                        const selectedGroup = this.rfq.groups.find((rfqGroup)=> {
                                            return group.id === rfqGroup.id
                                        });
                                        if(selectedGroup) {
                                            selectedTransporters = selectedGroup.transporters.map((transporter)=> {
                                                return transporter.id;
                                            })
                                        }
                                        return (
                                            <GroupContainer
                                            key={(index + 1)}
                                            selectedTransporters = {selectedTransporters}
                                            group={group} 
                                            autoSelectTransporters={this.rfq.autoSelectTransporters}
                                            toggleAllTransporters={this.toggleAllTransporters.bind(this, index)} 
                                            toggleTransporter={this.toggleTransporter.bind(this, index)} 
                                            viewMode={this.props.viewMode}
                                            />

                                        )
                                    })
                                }
                            </Fragment>
                        }
                        {(transporters || []).length > 0 && <div className="flex flex-between flex-middle mb-20 mt-40">
                            <SubHeading text={`All ${isHikal ? 'Service Providers' : 'transporters'}`} className=""/>
                            <Checkbox type="square" onCheck={this.checkAllTransporters} checked={this.state.isAllTransportersChecked}/>
                        </div>}
                        {
                            !this.state.isAllTransportersChecked && (transporters || []).map((transporter, index)=> {
                                return (
                                    <div key={index} className="flex ht-40 fs-16 fSemibold flex flex-middle pl-20 flex-between">
                                        <label className="flex-1">{transporter.name}</label>
                                        <Checkbox type='square' checked={this.rfq.transporters.find((rfqTransporter)=> {
                                            return rfqTransporter.id === transporter.id
                                        }) || this.state.isAllTransportersChecked} onCheck={this.selectAllTransporter.bind(this, transporter)}/>
                                    </div>
                                )
                            })
                        }
                    </div>}
                    <div className="col-2 ml-20 pcard">
                        <SubHeading text={'Selected Transporters'} className="pb-10 border-bottom-light"/>
                        {
                            (this.rfq.groups || []).map((group, index)=> {
                                return (
                                    <GroupContainer key={(index + 1)} selectedList={true} group={group} toggleAllTransporters={this.toggleAllTransporters.bind(this, index)} toggleTransporter={this.toggleTransporter.bind(this, index)} />
                                )
                            })
                        }
                        {this.state.isAllTransportersChecked && <SubHeading text="All transporters" className="mb-20 mt-40"/>}
                        {
                            !this.state.isAllTransportersChecked && (this.rfq.transporters || []).map((transporter, index)=> {
                                return (
                                    <div key={index} className="flex ht-40 fs-16 fSemibold flex flex-middle pl-20 flex-between">
                                        <label className="flex-1">{transporter.name}</label>
                                        {/* <Checkbox checked={transporter.isSelected} onCheck={this.selectAllTransporter.bind(this, index)}/> */}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default GroupingProviders;
